import dJSON from 'dirty-json';
import {
  animate, stagger, onScroll,
} from 'animejs';

/**
 * Module Init
 */
(() => {
  const moduleSelector = '.banner-usp';
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.banner-usp__items').insertAdjacentHTML('beforeend', /* html */ `
          <div class="banner-usp__item">
            <img src="${item.icon}" alt="${item.text}">
            <p>${item.text}</p>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * Animate
 */
(() => {
  document.querySelectorAll('.animate .banner-usp .banner-usp__items').forEach((section) => {
    if (!section.children.length) return;
    animate(Array.from(section.children), {
      x: ['-120px', 0],
      opacity: [0, 1],
      duration: 1700,
      delay: stagger(900),
      autoplay: onScroll({
        target: section,
        enter: 'bottom center',
        leave: 'bottom-=420 center',
        sync: 0.3,
        debug: false,
      }),
    });
  });
})();
